import PropTypes from 'prop-types';
import { animateScroll as scroll } from 'react-scroll';
import { actions, isValidHybridFlow } from '../util/actions';
import ErrorPane from '../ErrorPane';
import CloudServiceEmail from './CloudServiceEmail';
import HybridOptions from './HybridOptions';
import useRequireAuth from '../../hooks/useRequireAuth';
import { useHybrid } from '../hooks/useHybrid';

function HybridFlow({ onComplete, onCancel }) {
  scroll.scrollToTop();
  useRequireAuth();
  const data = useHybrid();

  if (!data || !data.action) {
    return null;
  }

  const handleComplete = async () => {
    const newData = await data.getHybrid();
    if (!newData || !isValidHybridFlow(newData.action)) {
      onComplete();
    }
  };

  switch (data.action) {
    case actions.cloudService:
      return (
        <CloudServiceEmail onComplete={handleComplete} onCancel={onCancel} />
      );
    case actions.hybridOptions:
      return <HybridOptions onComplete={onComplete} onCancel={onCancel} />;
    case actions.error:
      return <ErrorPane apiResponse={data} />;

    default:
      return null;
  }
}

HybridFlow.propTypes = {
  onComplete: PropTypes.func,
  onCancel: PropTypes.func,
};

export default HybridFlow;
